const t = {
  name: "Wifi",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 8.43L1.5 9.75C4.16 6.73 7.98 5 12 5C16.02 5 19.84 6.73 22.5 9.75L24 8.43C20.97 4.98 16.59 3 12 3C7.41 3 3.04 4.98 0 8.43Z" fill="currentColor"/>
<path d="M5.64711 12.6371C9.15658 9.12764 14.8634 9.12764 18.3729 12.6371L19.08 13.3442L20.4942 11.93L19.7871 11.2229C15.4966 6.93237 8.52342 6.93237 4.23289 11.2229L3.52579 11.93L4.94 13.3442L5.64711 12.6371Z" fill="currentColor"/>
<path d="M14.8329 16.1671C13.2734 14.6076 10.7366 14.6076 9.17711 16.1671L8.47 16.8742L7.05579 15.46L7.76289 14.7529C10.1034 12.4124 13.9066 12.4124 16.2471 14.7529L16.9542 15.46L15.54 16.8742L14.8329 16.1671Z" fill="currentColor"/>
<path d="M10.01 20C10.01 18.8977 10.9077 18 12.01 18C13.1123 18 14.01 18.8977 14.01 20C14.01 21.1023 13.1123 22 12.01 22C10.9077 22 10.01 21.1023 10.01 20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Wifi
};
